export {
    default as getExtensionFromFileName,
    getExtensionWithoutDotFromFileName,
} from './utils/getExtensionFromFileName';
export {
    default as numberToByteQuantifiedStringConverter,
} from './utils/numberToByteQuantifiedStringConverter';
export { default as isImageFile } from './utils/isImageFile';
export { default as isThumbnailableDocument } from './utils/isThumbnailableDocument';
export { getOfficeOnlineAppFromExtension } from './utils/getOfficeOnlineAppFromExtension';

// Types
export { OfficeOnlineApp } from './types/OfficeOnlineApp';
